<style lang="scss">

</style>

<template>
  <!-- eslint-disable -->
  <div class="post-search-page mb-4">
    <section class="d-flex full-width justify-content-between align-items-center mb-2">
      <h2>Your Calls</h2>
      <b-btn :to="{ name: 'request-call' }" variant="primary" v-if="user && user.in_cell_book_own_calls" >Request call</b-btn>
    </section>


    <b-card no-body class="mb-0">
      <section>
        <b-table
          class="data-table"
          hover
          :items="calls"
          :fields="headers"
          :current-page="currentPage"
          :per-page="0"
        >
          <template #cell(visitorName)="data">
            {{ data.item.visitor.firstname }} {{ data.item.visitor.lastname }}
          </template>
          <template #cell(booked_slot.start_date_time)="data">
            {{ data.item.booked_slot.start_date_time | formatDate }}
          </template>
          <template #cell(slot)="data">
            {{ data.item.booked_slot.slot_begin }} - {{ data.item.booked_slot.slot_end }}
          </template>

          <template #cell(actions)="data">
            <router-link :to="{ name: 'waiting-room', params: { id: data.item._id } }"
                         class="font-weight-bold d-block text-nowrap text-right">
              Enter waiting room
            </router-link>
          </template>
        </b-table>
        <b-row class="p-1" v-if="(totalRows > filters.limit) || totalRows === 0">
          <b-col md="6" class="m-1" v-if="totalRows > filters.limit">
            <b-pagination :total-rows="totalRows" :per-page="filters.limit" v-model="currentPage" class="my-0"/>
          </b-col>
          <p v-if="totalRows === 0" class="col-6 ml-2 my-1">No calls to show</p>
        </b-row>
      </section>
    </b-card>

<!--  Alt Design if wanted  -->
<!--    <div class="theme-color-wrapper p-2 menu-shadow">-->
<!--      <section v-if="!loading" class="contact-row-wrapper">-->
<!--        <div class="contact-row mobile-column mb-2 d-inline-flex align-items-center full-width pb-1"-->
<!--             v-for="call in calls" :key="call._id">-->
<!--          <section class="my-contacts-page__contact__details d-flex">-->
<!--            <h3 style="min-width: 350px">{{call.visitor.firstname}} {{call.visitor.lastname}}</h3>-->
<!--            <h3>{{ call.booked_slot.start_date_time | formatDate }} @ {{ call.booked_slot.slot_begin }} {{ call.booked_slot.slot_end }}</h3>-->
<!--          </section>-->
<!--          <div class="ui-spacer"></div>-->
<!--          <b-btn :to="{name: 'view-contact', params: {id: call._id}}" variant="outline-success">Enter Waiting Room</b-btn>-->
<!--        </div>-->
<!--        <p v-if="calls.length === 0">No calls available</p>-->
<!--      </section>-->
<!--    </div>-->

  </div>
  <!-- eslint-enable -->
</template>

<script>
import { mapState } from 'vuex';
import VisitsService from '@/services/VisitsService';
import moment from 'moment';

export default {
  name: 'Calls',
  components: {},
  data() {
    return {
      loading: true,
      headers: [
        { label: 'Visitor', key: 'visitorName' },
        { label: 'Date', key: 'booked_slot.start_date_time' },
        { label: 'Call Slot', key: 'slot' },
        { label: '', key: 'actions' },
      ],
      calls: [],
      currentPage: 1,
      totalRows: 10,
      pollInterval: null,
      filters: {
        status: 'Approved',
        limit: 10,
        skip: 0,
        sort: 'booked_slot.end_date_time',
        after: moment().subtract(1, 'days').format('YYYY-MM-DD'), // all calls from yesterday
      },
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
    }),
  },
  watch: {
    currentPage() {
      this.getCalls();
    },
  },
  beforeDestroy() {
    clearInterval(this.pollInterval);
  },
  async mounted() {
    await this.$store.dispatch('auth/refreshUser');
    this.getCalls();
    this.setUpPolling();
  },
  methods: {
    getCalls() {
      this.filters.skip = (this.currentPage - 1) * this.filters.limit;

      VisitsService.getVisits(this.filters).then(res => {
        this.loading = false;
        this.calls = res.data.data;
        this.totalRows = res.data.count;
      }).catch(err => {
        console.log('Error getting post ', err);
        this.$toast.error('Could not get calls, please refresh and try again', {
          toastClassName: ['toast-std', 'warning-toast'],
        });
      });
    },
    setUpPolling() {
      if (this.pollInterval) {
        clearTimeout(this.pollInterval);
      }
      this.pollInterval = setInterval(() => {
        this.getCalls();
      }, 10 * 1000);
    },
  },
};
</script>
